<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      Chỉ cho xóa thôi ^^
      <!-- <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Chọn nhân viên" prop="employeeId">
          <SelectEmployee
            v-model="form.employeeId"
            :selectProps="{
              placeholder: 'Chọn nhân viên',
            }"
          />
        </a-form-model-item>
        <a-form-model-item label="Ngày bắt đầu" prop="startDate">
          <a-date-picker
            type="startDate"
            placeholder="Chọn ngày bắt đầu"
            style="width: 100%;"
            v-model="form.startDate"
          />
        </a-form-model-item>
        <a-form-model-item label="Ngày kết thúc" prop="endDate">
          <a-date-picker
            type="date"
            placeholder="Chọn ngày kết thúc"
            style="width: 100%;"
            v-model="form.endDate"
          />
        </a-form-model-item>
      </a-form-model> -->
      <!-- <a-divider orientation="left">
        THÔNG TIN CẬP NHẬT
      </a-divider> -->
      <!-- <a-descriptions :column="1">
        <a-descriptions-item label="Tạo bởi">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions> -->
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Xác nhận xóa thông tin?"
          ok-text="Có"
          cancel-text="Không"
          @confirm="onDeletedItem"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Xóa
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Đóng
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Cập nhật
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import query from "../constant/query";
import SelectEmployee from "@/components/common/employee/select";

const rules = {
  employeeId: [{ required: true, message: "Thông tin không được bỏ trống" }],
  startDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
  endDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
};

export default {
  components: {},
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idItem: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // this.onUpdatedItem();
        } else {
          return false;
        }
      });
    },
    onUpdatedItem() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateDocumentAgencyIssued,
          variables: {
            id: this.form.id,
            title: this.form.title,
            address: this.form.address,
            description: this.form.description,
            status: this.form.status,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật  thành công!",
          });
          this.loadingBtn = false;
          if (data?.updateDocumentAgencyIssued?.id) {
            this.refreshAfterUpdated(data.updateDocumentAgencyIssued);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật  không thành công!",
          });
          console.log("Cập nhật  không thành công", err);
        });
    },
    onDeletedItem() {
      if (this?.idItem) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteOnBusiness,
            variables: {
              id: this.idItem,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa thành công!",
            });
            this.loadingBtn = false;
            if (data?.deleteOnBusiness?.id) {
              this.refreshAfterDeleted(data.deleteOnBusiness);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Thông báo",
              description: "Xóa  không thành công!",
            });
            console.log("Xóa  không thành công", err);
          });
      }
    },
    onChangeStatus(check) {
      if (check) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
